// DateRangePicker.jsx
import React,{useState}  from "react";
import DatePicker from "react-datepicker";
import { id } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

export default function DateRangePicker({startDate, setStartDate, endDate, setEndDate}) {
  
  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  return (
    <div className="flex flex-col gap-4">
      <div>
        <DatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={onChange}
          monthsShown={2}
          locale={id}
          dateFormat="dd MMM yyyy"
          className="w-full border px-3 py-2 rounded focus:ring-indigo-500"
          placeholderText="Pilih Tanggal"
        />
      </div>
    </div>
  );
}
